import type { DesktopApi } from '../../../desktop/src/shared';

export type {
  BackupEntry,
  DesktopApi,
  PrinterInfo,
  UpdateStatus,
} from '../../../desktop/src/shared';

declare global {
  interface Window {
    /** Present only inside the LabView desktop app. */
    quickreport?: DesktopApi;
  }
}

export const desktop = (): DesktopApi | null =>
  typeof window === 'undefined' ? null : (window.quickreport ?? null);
export const isDesktop = () => desktop() !== null;
